import { readLoginLanguageHint } from '@/entities/auth/cookies/loginState';
import { env } from '@/shared/config';
import { SUPPORTED_LOCALES, type SupportedLocale } from '@/shared/i18n/locales';
import { localePersistenceConfig } from './config';

const localeSet = new Set<string>(SUPPORTED_LOCALES);

export function normalizeLocale(value: string | null | undefined) {
  if (!value) return null;

  const normalized = value.toLowerCase();
  if (localeSet.has(normalized)) return normalized as SupportedLocale;

  const baseLocale = normalized.split('-')[0];
  return localeSet.has(baseLocale) ? (baseLocale as SupportedLocale) : null;
}

export function readPersistedLocale() {
  try {
    return normalizeLocale(window.localStorage.getItem(localePersistenceConfig.storageKey));
  } catch {
    return null;
  }
}

export function resolvePreferredLocale() {
  return normalizeLocale(readLoginLanguageHint()) ?? readPersistedLocale() ?? env.defaultLocale;
}
